var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBioEditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09277 4.3487C8.17127 4.27303 8.29591 4.27417 8.373 4.35127L11.9159 7.89413C11.995 7.97325 11.9938 8.10189 11.9132 8.17954L6.54792 13.3516C6.51064 13.3876 6.46089 13.4076 6.40911 13.4076H2.86406C2.75361 13.4076 2.66406 13.3181 2.66406 13.2076V9.66688C2.66406 9.61256 2.68615 9.56059 2.72526 9.52289L8.09277 4.3487ZM8.37218 6.29688C8.29541 6.22011 8.17142 6.21861 8.09281 6.29348L4.06849 10.1268C4.02886 10.1646 4.00643 10.2169 4.00643 10.2717V11.8653C4.00643 11.9757 4.09598 12.0653 4.20643 12.0653H5.80574C5.8571 12.0653 5.90649 12.0455 5.94368 12.0101L9.96509 8.17951C10.0464 8.10201 10.048 7.97272 9.96857 7.89327L8.37218 6.29688ZM10.1914 2.4198C10.2706 2.34501 10.3951 2.34734 10.4714 2.42504L13.9537 5.9695C14.0306 6.0478 14.0301 6.17347 13.9525 6.25109L13.093 7.1105C13.0149 7.18861 12.8883 7.18861 12.8102 7.1105L9.27138 3.57169C9.1917 3.492 9.19355 3.36224 9.27548 3.28487L10.1914 2.4198Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBioEditor);
export default __webpack_public_path__ + "static/media/bio-editor.2d25a4654bd5fe7301427e53462bd52c.svg";
export { ForwardRef as ReactComponent };